import React, { useState } from 'react';
import { Phone, Mail, Megaphone, CheckCircle } from 'lucide-react';

const AnnouncementBar = () => {
  const [copied, setCopied] = useState(null); // 'phone' or 'email'

  const handleCopy = (text, type) => {
    navigator.clipboard.writeText(text);
    setCopied(type);
    setTimeout(() => setCopied(null), 1500);
  };

  return (
    <div className="bg-[#E62E2D] text-white py-2 px-4 text-sm shadow-md">
      <div className="container mx-auto flex flex-col md:flex-row justify-between items-center text-center md:text-left space-y-2 md:space-y-0">
        
        {/* Left: Announcement */} 
        <div className="flex items-center justify-center space-x-2">
          <Megaphone size={18} className="text-white animate-pulse" />
          <span className="font-medium tracking-wide">
            Welcome to Isuzu Gujranwala Motors – Trucks for Life!
          </span>
        </div>

        {/* Right: Contact info */}
        <div className="flex flex-wrap justify-center md:justify-end items-center space-x-6">
          
          {/* Phone */}
          <div
            className="flex items-center cursor-pointer select-none"
            onClick={() => handleCopy('+923129388531', 'phone')}
          >
            <Phone size={16} className="mr-2" />
            {copied === 'phone' ? (
              <span className="font-semibold flex items-center space-x-1 animate-fade-scale">
                <CheckCircle size={14} className="text-white" />
                <span>Copied!</span>
              </span>
            ) : (
              <span className="font-medium hover:underline transition-all">
                +92-312-9388531
              </span>
            )}
          </div>

          {/* Email */}
          <div
            className="flex items-center cursor-pointer select-none"
            onClick={() => handleCopy('info@isuzugujranwala.com', 'email')}
          >
            <Mail size={16} className="mr-2" />
            {copied === 'email' ? (
              <span className="font-semibold flex items-center space-x-1 animate-fade-scale">
                <CheckCircle size={14} className="text-white" />
                <span>Copied!</span>
              </span>
            ) : (
              <span className="font-medium hover:underline transition-all">
                info@isuzugujranwala.com
              </span>
            )}
          </div>
        </div>
      </div>

      {/* Custom animations */}
      <style>{`
        @keyframes fadeScale {
          0% {
            opacity: 0;
            transform: scale(0.8);
          }
          50% {
            opacity: 1;
            transform: scale(1.05);
          }
          100% {
            opacity: 1;
            transform: scale(1);
          }
        }
        .animate-fade-scale {
          animation: fadeScale 0.4s ease-in-out;
        }
      `}</style>
    </div>
  );
};

export default AnnouncementBar;
